const Footer = () => {
    return (
        <footer>
            <p>Copyright © Mark Kim at Juno College</p>
        </footer>
    )
}

export default Footer;